import clsx from "clsx";
import MoonLoader from "react-spinners/MoonLoader";
import "./loader.scss";

type LoaderProps = {
    text?: string;
    loading: boolean;
    size?: number;
    color?: string;
    isInline?: boolean;
    textSize?: "normal" | "small";
};

const defaults = {
    size: 150,
    color: "#63c19f",
};

const Loader = (props: LoaderProps) => {
    return (
        <div className={clsx("loader-container", props.isInline && "inline")}>
            {props.text ? (
                <span>
                    <h3
                        className={clsx(
                            "fw-bold px-4 pb-2 text-center loading-text",
                            props.textSize && `loading-text--${props.textSize}`,
                        )}
                    >
                        {props.text}
                    </h3>
                </span>
            ) : null}

            <MoonLoader
                data-cy="loader"
                color={props.isInline ? "white" : (props.color ?? defaults.color)}
                loading={props.loading}
                size={props.size ?? defaults.size}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
    );
};

export default Loader;
